module.exports = __webpack_public_path__ + "static/media/important-alert.cf64a9dc.svg";